module.exports = __webpack_public_path__ + "img/mta-logo.0bb96c00.png";